import React from 'react';
import { X, Mail } from 'lucide-react';

const ThankYouModal = ({ showThankYouModal, setShowThankYouModal }) => {
  if (!showThankYouModal) return null;

  return (
    <div className="thank-you-modal-overlay" onClick={() => setShowThankYouModal(false)}>
      <div className="thank-you-modal" onClick={(e) => e.stopPropagation()}>
        <button
          className="thank-you-modal-close"
          onClick={() => setShowThankYouModal(false)}
        >
          <X size={18} />
        </button>

        <div className="thank-you-icon">
          <Mail />
        </div>

        <h3 className="thank-you-title">Thank You!</h3>

        <p className="thank-you-message">
          Your message has been sent successfully. I'll get back to you as soon as possible!
        </p>

        <button
          className="thank-you-button"
          onClick={() => setShowThankYouModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ThankYouModal;
